import {useInfiniteQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpGetAccessRates} from '../http/budget.http'
import {ExternalCostCode} from '../types'
import {infiniteQueryFetchNextPage} from '@/utilities/helpers'

export const useGetAccessRates = ({code}: {code: ExternalCostCode}) => {
    const query = useInfiniteQuery({
        queryKey: [QUERY_KEYS.ACCESS_RATES, code],
        queryFn: ({pageParam = 1}) =>
            httpGetAccessRates({
                params: {
                    code,
                    page: pageParam,
                    limit: 20
                }
            }),
        initialPageParam: 1,
        getNextPageParam: ({meta}) => (meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null)
    })

    return {
        ...query,
        fetchNextPage: () => infiniteQueryFetchNextPage(query),
        remappedData: query.data?.pages[0]?.data?.length ? query.data.pages.flatMap(page => page.data) : []
    }
}
